(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PositionDetailController', PositionDetailController);

    PositionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Position', 'InfoPosition'];

    function PositionDetailController($scope, $rootScope, $stateParams, previousState, entity, Position, InfoPosition) {
        var vm = this;

        vm.position = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:positionUpdate', function(event, result) {
            vm.position = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
